import { render, staticRenderFns } from "./OrderStepDeliveryData.vue?vue&type=template&id=24dba10d&"
import script from "./OrderStepDeliveryData.vue?vue&type=script&lang=js&"
export * from "./OrderStepDeliveryData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports